import type {
  ClassificationSource,
  ConversationKind,
  Folder,
  Intent,
  Language,
  PageConnection,
  Platform,
  SuggestionStatus,
} from '@rp/contracts'
import type { ChipVariant, StatusTone } from '../../design'

export const INTENT_LABELS: Record<Intent, string> = {
  question: '提問',
  complaint: '客訴',
  sales_lead: '潛在客戶',
  praise: '稱讚',
  spam: '垃圾訊息',
  troll: '酸民',
  reaction: '表情回應',
  other: '其他',
}

export const FOLDER_LABELS: Record<Folder, string> = { inbox: '收件匣', spam: '垃圾', muted: '已收合' }
export const KIND_LABELS: Record<ConversationKind, string> = { comment_thread: '留言', dm: '私訊' }
export const PLATFORM_LABELS: Record<Platform, string> = { facebook: 'Facebook', instagram: 'Instagram' }
export const LANGUAGE_LABELS: Record<Language, string> = {
  yue: '粵語',
  cmn: '普通話',
  en: '英文',
  mixed: '混用',
  other: '其他',
}
export const CLASSIFICATION_SOURCE_LABELS: Record<ClassificationSource, string> = {
  rule: '規則判定',
  llm: 'AI 判定',
  human: '人手修正',
}
export const SUGGESTION_STATUS_LABELS: Record<SuggestionStatus, string> = {
  pending: '建議生成中',
  ready: '已有建議',
  no_confident: '沒有把握的建議',
  failed: '建議生成失敗',
  stale: '建議已過期',
}

const INTENT_TONES: Record<Intent, StatusTone> = {
  complaint: 'danger',
  question: 'info',
  sales_lead: 'info',
  troll: 'warning',
  spam: 'warning',
  reaction: 'neutral',
  praise: 'success',
  other: 'neutral',
}

const CLASSIFICATION_SOURCE_TONES: Record<ClassificationSource, StatusTone> = {
  llm: 'info',
  rule: 'neutral',
  human: 'neutral',
}

const SUGGESTION_STATUS_TONES: Record<SuggestionStatus, StatusTone> = {
  pending: 'neutral',
  ready: 'success',
  no_confident: 'warning',
  failed: 'danger',
  stale: 'neutral',
}

const SUGGESTION_STATUS_VARIANTS: Record<SuggestionStatus, ChipVariant> = {
  pending: 'outline',
  ready: 'outline',
  no_confident: 'wash',
  failed: 'wash',
  stale: 'outline',
}

export const intentTone = (intent: Intent | null): StatusTone => (intent === null ? 'neutral' : INTENT_TONES[intent])
export const classificationSourceTone = (source: ClassificationSource): StatusTone => CLASSIFICATION_SOURCE_TONES[source]
export const suggestionStatusTone = (status: SuggestionStatus): StatusTone => SUGGESTION_STATUS_TONES[status]
export const suggestionStatusVariant = (status: SuggestionStatus): ChipVariant => SUGGESTION_STATUS_VARIANTS[status]

export const PAGE_CONNECTION_LABELS: Record<Exclude<PageConnection, 'connected'>, string> = {
  disconnected: '粉專已斷線，現在無法回覆',
  removed: '粉專已移除，現在無法回覆',
}

export const pageProblemOf = (connection: PageConnection): string | null =>
  connection === 'connected' ? null : PAGE_CONNECTION_LABELS[connection]
